function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.8886 4.60448H27.5594C27.5029 2.05635 25.4033 0 22.8251 0H16.1749C13.5971 0 11.4975 2.05635 11.441 4.60448H1.11186C0.497668 4.60448 0 5.09891 0 5.7091V9.71311C0 10.3233 0.497668 10.8177 1.11186 10.8177H3.65268V39.2925C3.65268 41.8884 5.77855 44 8.39186 44H30.6081C33.2214 44 35.3473 41.8884 35.3473 39.2925V10.8173H37.8881C38.5023 10.8173 39 10.3229 39 9.71267V5.7091C39.0004 5.09891 38.5028 4.60448 37.8886 4.60448ZM16.1749 2.20923H22.8251C24.1771 2.20923 25.2806 3.27497 25.3357 4.60448H13.6652C13.7203 3.27497 14.8233 2.20923 16.1749 2.20923ZM33.124 39.2925C33.124 40.6702 31.9957 41.7907 30.6086 41.7907H8.39186C7.00471 41.7907 5.87639 40.6702 5.87639 39.2925V10.8173H33.124V39.2925ZM36.7767 8.60806H2.22372V6.81372H36.7763V8.60806H36.7767Z",
  fill: "#A0A0A0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3843 40.296C12.9985 40.296 13.4962 39.8016 13.4962 39.1914V13.4167C13.4962 12.8065 12.9985 12.3121 12.3843 12.3121C11.7701 12.3121 11.2725 12.8065 11.2725 13.4167V39.1914C11.2725 39.8016 11.7701 40.296 12.3843 40.296Z",
  fill: "#A0A0A0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 40.296C20.1142 40.296 20.6119 39.8016 20.6119 39.1914V13.4167C20.6119 12.8065 20.1142 12.3121 19.5 12.3121C18.8859 12.3121 18.3882 12.8065 18.3882 13.4167V39.1914C18.3882 39.8016 18.8859 40.296 19.5 40.296Z",
  fill: "#A0A0A0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.6163 40.296C27.2304 40.296 27.7281 39.8016 27.7281 39.1914V13.4167C27.7281 12.8065 27.2304 12.3121 26.6163 12.3121C26.0021 12.3121 25.5044 12.8065 25.5044 13.4167V39.1914C25.5044 39.8016 26.0021 40.296 26.6163 40.296Z",
  fill: "#A0A0A0"
});

var SvgIconTrash = function SvgIconTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 44,
    viewBox: "0 0 39 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-trash.cf929cdc.svg";
export { ForwardRef as ReactComponent };